<div class="response table-responsive m-b-2">
    <table class="est-table" cellspacing="0">
        <tbody>
            <!-- Use Angular's keyvalue pipe to iterate over object keys -->

            <tr>
                <td>Property Uid</td>
                <td>{{response?.property_uid || '-'}}</td>
            </tr>
            <tr>
                <td>Land Frontage</td>
                <td>{{response?.land_frontage || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Midpoint</td>
                <td>{{response?.land_value_midpoint || '-'}}</td>
            </tr>
            <tr>
                <td>Project Name</td>
                <td>{{response?.project_name || '-'}}</td>
            </tr>
            <tr>
                <td>Visible Area As Ratio Of Land Area</td>
                <td>{{response?.visible_area_as_ratio_of_land_area || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Lower Range</td>
                <td>{{response?.land_value_lower_range || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Higher Range</td>
                <td>{{response?.land_value_higher_range || '-'}}</td>
            </tr>
            <tr>
                <td>Property Build Year</td>
                <td>{{response?.property_build_year || '-'}}</td>
            </tr>
            <tr>
                <td>Property Age</td>
                <td>{{response?.property_age || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Bedrooms</td>
                <td>{{response?.number_of_bedrooms || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Bathrooms</td>
                <td>{{response?.number_of_bathrooms || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Square Corners</td>
                <td>{{response?.number_of_square_corners || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Bevelled Corners</td>
                <td>{{response?.number_of_bevelled_corners || '-'}}</td>
            </tr>
            <tr>
                <td>Road Width</td>
                <td>{{response?.road_width ? response?.road_width : '-'}}</td>
            </tr>
            <tr>
                <td>Total Open Frontage</td>
                <td>{{response?.total_open_frontage || '-'}}</td>
            </tr>
            <tr>
                <td>Percentage Length Open</td>
                <td>{{response?.percentage_length_open || '-'}}</td>
            </tr>

            <tr>
                <td>Special View</td>
                <td>{{response?.special_view ? response?.special_view : "-"}}</td>
            </tr>
            <tr>
                <td>Land Area</td>
                <td>{{response?.land_area ? (response?.land_area | number : "1.0-1"): "-"}}</td>
            </tr>

            <tr>
                <td>Neigh Name</td>
                <td>{{response?.neigh_name || '-'}}</td>
            </tr>
            <tr>
                <td>Block Name</td>
                <td>{{response?.block_name || '-'}}</td>
            </tr>
            <tr>
                <td>Street Name</td>
                <td>{{response?.street_name || '-'}}</td>
            </tr>
        </tbody>
    </table>
    <table class="w-100" cellspacing="0">
        <tbody>
            <tr>
                <td>Land Frontage Direction Orientation</td>
                <td>
                    <table class="child-table w-100" cellspacing="0">
                        <thead>
                            <tr>
                                @for (agrKey of direction | keyvalue ; track $index) {
                                <th class="text-uppercase">{{agrKey.key}}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (agrVal of direction | keyvalue ; track $index) {
                            <td>{{agrVal.value ? agrVal.value : '-'}}</td>
                            }
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>Transaction Count (3 Months)</td>
                <td>

                    <table class="child-table w-100" cellspacing="0">
                        <thead>
                            <tr>
                                <th>6 Months</th>
                                <th>3 Months</th>
                                <th>1 Months</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td>{{response?.transaction_count?.six_months || '-'}}</td>
                            <td>{{response?.transaction_count?.three_months || '-'}}</td>
                            <td>{{response?.transaction_count?.one_year || '-'}}</td>
                        </tbody>
                    </table>

                </td>
            </tr>
            <tr>
                <td>Average Rate</td>
                <td>
                    @if(response?.average_rate?.length){
                    <table class="child-table w-100" cellspacing="0">
                        <thead>
                            <tr>
                                @for (agrKey of response?.average_rate | keyvalue ; track $index) {
                                <th>{{agrKey.key}}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (agrVal of response?.average_rate | keyvalue ; track $index) {
                            <td>{{agrVal.value ? agrVal.value : '-'}}</td>
                            }
                        </tbody>
                    </table>
                    }@else {
                    -
                    }
                </td>
            </tr>
        </tbody>
    </table>
</div>